import { useContext } from 'react';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { Box } from '@mui/material';

import { SiteFinanceTableContext } from '../../SiteFinanceContext';
import { SiteFinanceInfoItem } from '../SiteFinanceInfoItem/SiteFinanceInfoItem';

export const QuickStatsPopover = () => {
  const { lifetimeData } = useContext(SiteFinanceTableContext);

  return (
    <Box
      sx={{
        padding: '16px',
        display: 'flex',
        gap: '16px',
        flexWrap: 'wrap',
        maxWidth: '1050px'
      }}
    >
      <SiteFinanceInfoItem
        icon={<MonetizationOnIcon />}
        title="Total Earned (Lifetime):"
        amount={lifetimeData.totalEarnedSiteAmount}
      />
      <SiteFinanceInfoItem
        icon={<MonetizationOnIcon />}
        title="Amount Withheld from Payment (Lifetime):"
        amount={lifetimeData.totalWithheldFromPayment}
      />
      <SiteFinanceInfoItem
        icon={<MonetizationOnIcon />}
        title="Total Payment (Lifetime):"
        amount={lifetimeData.totalPaymentLifetime}
      />
    </Box>
  );
};
